import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../core/services/shared-service';

@Component({
  selector: 'app-no-access',
  templateUrl: './no-access.component.html',
  styleUrls: ['./no-access.component.css']
})
export class NoAccessComponent implements OnInit {
  message: string = "It is possible this is a problem that will be resolved in a few minutes, so please try again soon.";

  constructor(private sharedService: SharedService) { }

  ngOnInit(): void {
    if (this.sharedService.NoAccessMessage !== '') {
      this.message = this.sharedService.NoAccessMessage;
    }
  }
}
